import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DynamicReportService {
    constructor(private readonly httpClient: HttpClient) { }

    getDynamicReport(columns: string, filters: string): Observable<any> {
        let params = new HttpParams();
        return this.httpClient.get(
            `${environment.apiUrl}/dynamic-report?distinct=${columns}${filters}`, { params: params }
        );
    }
}